import { Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ControlFailureSectionProp } from ".";
import { DATE_UTIL } from "../../../../../utils/dateUtils";
import UTIL from "../../../../../utils/utils";


const LearningActionViewSection = (props: ControlFailureSectionProp) => {

    const { t } = useTranslation();
    const { data } = props;

    return (
        <div className="section-wrapper">

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbLearningPoints")}
                    >
                        <span>{data.learning_points}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbActionPointsDescription")}
                    >
                        <span>{data.action_points_description}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbTargetCompletionDate")}
                    >
                        <span>{DATE_UTIL.convertServerToViewFormat(data.target_completion_date)}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbActualCompletionDate")}
                    >
                        <span>{DATE_UTIL.convertServerToViewFormat(data.actual_completion_date)}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbSupervisorResponsible")}
                    >
                        <span>{data.supervisor_responsible}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbStatusDocumentation")}
                    >
                        <span>{UTIL.getStatusDocumentationName(data.status)}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.learningPoinCheck")}
                    >
                        <span>{data.additional_documentation ? t("ControlFailure.lbYes") : t("ControlFailure.lbNo")}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbAdditionalDocumentationNotes")}
                    >
                        <span>{data.location_of_documentation}</span>
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default LearningActionViewSection;